import React from "react";

const NotificationsModal = ({ show, onClose, children }) => {
    return (
        <div>
            <div
                className={`${
                    !show && "hidden duration-300"
                } h-full w-[500px] fixed md:fixed md:top-0 md:bottom-0 md:right-0 z-30 md:z-[60] bg-white p-2 md:p-0 overflow-hidden`}
            >
                {children}
            </div>
        </div>
    );
};

export default NotificationsModal;
